<template lang="pug">
v-content
  v-container
    v-toolbar.elevation-1(color="white")
      v-toolbar-title {{ $route.name }}
      v-divider(class="mx-2" inset vertical)
      v-spacer
    v-stepper(v-model="e1")
      v-stepper-items
        v-stepper-content(step="1")
          v-card.mb-12(height="auto")
            v-layout(row, wrap)
              v-flex(xs10, sm7)
                v-alert(
                  v-if="alertPhoneNumber",
                  style="margin-left: 15px",
                  dense,
                  type="error"
                ) Format Nomor Handphone Salah
                br
              v-flex(xs1, sm5)

              v-flex(xs3, sm1)
                p.headerSection Email
              v-flex(xs9, sm1)
              v-flex(xs1, sm1)
              v-flex(xs9, sm4)
                v-text-field.inputDefault(
                  v-model="email",
                  label="Email",
                  disabled
                )
              v-flex(xs1 sm1)
                v-btn(text style="margin-top:-10px" @click="e1 = 2")
                  v-icon edit
              v-flex(xs1, sm3)

              v-flex(xs3, sm3)
                p.headerSection 
                  span(class="mustFill") *
                  span  Nama
              v-flex(xs8, sm4)
                v-text-field.inputDefault(v-model="name", label="Nama")
              v-flex(xs1, sm4)

              v-flex(xs3, sm3)
                p.headerSection 
                  span(class="mustFill") *
                  span  NIK
              v-flex(xs8, sm4)
                v-text-field.inputDefault(v-model="nik", label="Nik")
              v-flex(xs1, sm4)

              v-flex(xs3, sm3)
                p.headerSection 
                  span(class="mustFill") *
                  span  Jabatan
              v-flex(xs8, sm4)
                v-text-field.inputDefault(v-model="title", label="Jabatan")
              v-flex(xs1, sm4)
  
              v-flex(xs3, sm3)
                p.headerSection 
                  span(class="mustFill") *
                  span  Departemen
              v-flex(xs8, sm6)
                v-menu(
                    v-model="openModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    :attach="true")
                    template(v-slot:activator="{ on }")
                      v-text-field(
                       v-model="department"
                        label="Departemen"
                        readonly
                        v-on="on")
                    ModalDepartment(:openModal="openModal" @closeModal="openModal = false" @selectedDepartment ="updateDepartment" :departmentData="department")
              v-flex(xs1, sm2)

              v-flex(xs3, sm3)
                p.headerSection Nomor Handphone/Whatsapp
              v-flex(xs8, sm4)
                v-text-field.inputDefault(
                  v-model="phone",
                  label="Nomor Handphone/Whatsapp",
                  hint="Gunakan format +62. e.g. +6281234567",
                  persistent-hint
                )
              v-flex(xs1, sm4)

              v-flex(xs3, sm3)
                p.headerSection 
                  span(class="mustFill") *
                  span  Group Level
              v-flex(xs8 sm4)
                v-select(
                  v-model="groupLevel",
                  label="Group Level",
                  :items="listGroupLevel",
                  item-text="text",
                  item-value="value"
                  multiple
                  chips
                  persistent-hint
                )
              v-flex(xs1, sm4)
              
              v-flex(xs3, sm3 v-if="groupLevel.includes('PIC')")
                p.headerSection 
                  span(class="mustFill") *
                  span  Location
              v-flex(
                v-if="groupLevel.includes('PIC')"
                xs8,
                sm4,
              )
                v-select(
                  v-model="picLocation",
                  label="Location",
                  :items="listLocation",
                  item-text="value",
                  item-value="value"
                )
              v-flex(xs1, sm4  v-if="groupLevel.includes('PIC')")

              v-flex(v-if="groupLevel.some(gl => ['PIC','PJO','SAFETYMITRA','DIVHEAD','CUSTODIANDIVHEAD','TEAMLEADER','WASKAT'].includes(gl))", xs3, sm3 )
                p.headerSection 
                  span(class="mustFill") *
                  span  Companies
              v-flex(xs8, sm6 v-if="groupLevel.some(gl => ['PIC','PJO','SAFETYMITRA','DIVHEAD','CUSTODIANDIVHEAD','TEAMLEADER','WASKAT'].includes(gl))")
                v-menu(
                    v-model="openModalComp"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                    template(v-slot:activator="{ on }")
                      v-text-field(
                       v-model="companies"
                        label="Companies"
                        readonly
                        v-on="on")
                    ModalCompanies(:openModal="openModalComp" @closeModal="openModalComp = false" @selectedCompany ="updateCompanies" :compData="companies")
              v-flex(xs1, sm2)

              v-flex(xs12)
                v-layout(
                  row,
                  wrap,
                  style="margin-left: unset; margin-right: unset;"
                )
                  v-flex(xs3, sm3)
                    p.headerSection 
                      span Non Aktifkan User
                  v-flex(xs9, sm9, align-top)
                    v-sheet
                      v-switch(
                        style="margin-top: 0;"
                        v-model="isInactive",
                        inset
                        :label="`${isInactive ? 'Ya' : 'Tidak'}`"
                      )

              v-flex(xs3, sm3)
                p.headerSection Last Login
              v-flex(xs8, sm3)
                v-chip(
                  v-if="last_login && last_login !== ''",
                  class="ma-0"
                ) {{ last_login }}
                v-chip(
                  v-else,
                  class="ma-0"
                ) No Last Login Info
              v-flex(xs1, sm4)

              v-flex(xs3, sm3)
                p.headerSection Device
              v-flex(xs8, sm7)
                v-text(
                  v-if="device && device !== ''",
                  
                ) {{ device }}
                v-text(
                  v-else,
                  
                ) No Device Info
              v-flex(xs1, sm2)

          v-btn(
            color="primary",
            :disabled="!isAllowedToSubmit",
            @click="submit()"
          ) Submit
          v-btn(text, @click="backHome()") Cancel
        v-stepper-content(step="2")
          v-card.mb-12(height="auto")
            v-layout(row, wrap)
              template(v-if="alertNotFound")
                v-flex(xs10, sm7)
                  v-alert(
                    style="margin-left: 15px",
                    dense,
                    type="warning"
                  ) Nomor Tidak Terdaftar di Database iSafe
                  br
                v-flex(xs1, sm4)

              template(v-if="alertAlreadyRegistered")
                v-flex(xs10, sm7)
                  v-alert(
                    style="margin-left: 15px",
                    dense,
                    type="error"
                  ) Email Telah Terdaftar di Database iPermit
                  br
                v-flex(xs1, sm5)

              template(v-if="alertIncorrectEmailFormat")
                v-flex(xs10, sm7)
                  v-alert(
                    style="margin-left: 15px",
                    dense,
                    type="error"
                  ) Email Yang Terdaftar di Database iSafe Tidak Memenuhi Format Email Yang Valid
                  br
                v-flex(xs1, sm5)

              template(v-if="alertServerError")
                v-flex(xs10, sm7)
                  v-alert(
                    style="margin-left: 15px",
                    dense,
                    type="error"
                  ) Telah Terjadi Kesalahan, Coba Beberapa Saat Lagi
                  br
                v-flex(xs1, sm5)

              v-flex(xs3, sm3)
                p.headerSection 
                  span(class="mustFill") *
                  span  Nomor iSafe
              v-flex(xs3, sm2)
                v-text-field.inputDefault(
                  v-model="isafe_no",
                  label="Nomor iSafe"
                )
              v-flex(xs1, sm1)

              v-flex(xs3, sm2)
                v-btn(
                  style="font-size: 14px; letter-spacing: 0px; height: 30px",
                  color="green",
                  :disabled="!isafe_no",
                  @click="cekUserIsafe()"
                ) Cek Email
              v-flex(xs1, sm4)

              v-flex(xs3, sm1)
                p.headerSection Email
              v-flex(xs9, sm1)
              v-flex(xs1, sm1)
              v-flex(xs10, sm4)
                v-text-field.inputDefault(
                  v-model="newEmail",
                  label="Email",
                  disabled
                )
              v-flex(xs1, sm4)
          v-btn(
            color="primary",
            @click="changeEmail(); scrollTop()",
            :disabled="!isAllowedToContinue"
          ) Change Email
          v-btn(text, @click="backStep()") Cancel
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import ModalDepartment from "../components/ModalDepartment.vue";
import ModalCompanies from "../components/ModalCompanies.vue";
export default {
  name: "EditUser",
  components: {
    ModalDepartment,
    ModalCompanies
  },
  props: {},
  data() {
    return {
      e1: 1,
      isafe_no: "",
      alertServerError: false,
      alertNotFound: false,
      alertIncorrectEmailFormat: false,
      alertAlreadyRegistered: false,
      alertPhoneNumber: false,
      email: "",
      newEmail: "",
      name: "",
      nik: "",
      title: "",
      openModal: false,
      openModalComp : false,
      department: [],
      phone: "",
      groupLevel: [],
      picLocation: "",
      locationOptions: ["HO", "MITRA"],
      listLocation: [
        {
          value: "HO",
        },
        {
          value: "MITRA",
        },
      ],
      companies: [],
      listDepartment: [],
      listCompany: [],

      listGroupLevel: [
        {
          text: "PIC",
          value: "PIC",
        },
        {
          text: "PJO",
          value: "PJO",
        },
        {
          text : "SAFETY MITRA",
          value: "SAFETYMITRA",
        },
        {
          text : "SAFETY INTERNAL",
          value: "SAFETYINTERNAL",
        },
        {
          text: "SECHEAD",
          value: "SECHEAD",
        },
        {
          text: "DIC",
          value: "DIC",
        },
        {
          text: "DIVHEAD",
          value: "DIVHEAD",
        },
        {
          text: "GENERAL AFFAIR",
          value: "GA",
        },
        {
          text: "SECURITY DEPT",
          value: "SECURITYDEPT",
        },
        {
          text: "DIVHEADHSE",
          value: "DIVHEADHSE",
        },
        {
          text: "CUSTODIAN DEPT. HEAD",
          value: "CUSTODIAN",
        },
        {
          text: "CUSTODIAN DIV. HEAD",
          value: "CUSTODIANDIVHEAD",
        },
        {
          text: "TEAM LEADER",
          value: "TEAMLEADER",
        },
        {
          text: "PNC",
          value: "PNC",
        },
        {
          text: "KTT",
          value: "KTT",
        },
        {
          text: "WASKAT",
          value: "WASKAT",
        },
      ],
      isPjs: false,
      isInactive: false,
      device:"",
      last_login:"",
    };
  },
  async mounted() {
    if (!this.dataUsers.isAdmin) {
      alert("Anda tidak punya hak akses untuk mengakses halaman ini");
      this.$router.push("my-approval-list");
    }
    this.$store.dispatch("fetchDataEditUser", this.$route.query.email);
    const listDepartmentResult = await axios.get(
      `${this.API_URL}/v1/requests/get-master-data?type=department`,
      {
        headers: { Authorization: `Bearer ${this.token}` },
      }
    );
    this.listDepartment = listDepartmentResult.data.data;
    const listCompanyResult = await axios.get(
      `${this.API_URL}/v1/requests/get-master-data?type=company`,
      {
        headers: { Authorization: `Bearer ${this.token}` },
      }
    );
    this.listCompany = listCompanyResult.data.data;
  },
  computed: {
    ...mapState(["dataUsers", "API_URL", "token", "dataEditUser", "tokenIsafe"]),
    isAllowedToContinue: function () {
      return !!this.email && !this.alertAlreadyRegistered;
    },
    isAllowedToSubmit: function () {
      return (
        !!this.email &&
        !!this.name &&
        !!this.nik &&
        !!this.title &&
        this.groupLevel.length > 0 &&
        this.department.length > 0 &&
        (this.groupLevel.includes("PIC") ? this.picLocation : true) &&
        (this.groupLevel.includes("PIC") ? this.companies[0] : true)
      );
    },
  },
  methods: {
    backStep() {
      this.e1--;
    },
    updateDepartment(data) {
      this.department = data;
    },
    updateCompanies(data) {
      this.companies = data;
    },
    scrollTop() {
      window.scrollTo(0, 0);
    },
    backHome() {
      this.$router.push("/user-list");
    },
    add() {
      this.companies.push({ name: "" });
    },
    remove(index) {
      this.companies.splice(index, 1);
    },
    emailRegex(email) {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      );
    },
    changeEmail() {
      this.email = this.newEmail;
      this.e1 = 1;
    },
    async cekUserIsafe() {
      this.newEmail = "";
      this.alertServerError = false;
      this.alertNotFound = false;
      this.alertAlreadyRegistered = false;
      this.alertIncorrectEmailFormat = false;
      try {
        const result = await axios.post(
          `${this.API_URL}/v1/employees/authenticateEmployeeByIsafeNo`,
          { isafe_no: this.isafe_no },
          {
            headers: { Authorization: `Bearer ${this.tokenIsafe}` },
          }
        );
        if (!this.emailRegex(result.data.data.email)) {
          return (this.alertIncorrectEmailFormat = true);
        }
        const resultCheck = await axios.get(
          `${this.API_URL}/v1/requests/get-user?email=${result.data.data.email}`,
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        );
        if (!resultCheck.data.message) {
          this.alertAlreadyRegistered = true;
        }
        this.newEmail = result.data.data.email;
      } catch (e) {
        if (e.message.includes("500")) {
          this.alertServerError = true;
        } else {
          this.alertNotFound = true;
        }
      } finally {
        this.$store.state.loader = false;
      }
    },
    async submit() {
      try {
        this.alertPhoneNumber = false;
        if (/^(\+62)[0-9]{7,14}$/.test(this.phone) == false && this.phone) {
          this.scrollTop();
          return (this.alertPhoneNumber = true);
        }
        let locations = [];
        if (
          this.groupLevel.includes("DIC") ||
          this.groupLevel.includes("SECHEAD") || this.groupLevel.includes('DIVHEAD')
        ) {
          locations.push("HO");
        }
        if (
          this.groupLevel.includes("PJO") ||
          this.groupLevel.includes("CUSTODIAN") || this.groupLevel.includes("SAFETYMITRA") || this.groupLevel.includes("TEAMLEADER") || this.groupLevel.includes("CUSTODIANDIVHEAD")
        ) {
          locations.push("MITRA");
        }
        if (
          this.groupLevel.includes("PNC") ||
          this.groupLevel.includes("KTT") || this.groupLevel.includes("SAFETYINTERNAL") || this.groupLevel.includes("DIVHEADHSE") || 
          this.groupLevel.includes("GA") || this.groupLevel.includes("SECURITYDEPT") ||
          this.groupLevel.includes("WASKAT")
        ) {
          locations = ["HO", "MITRA"];
        }
        if (this.groupLevel.includes("PIC")) {
          const index = locations.indexOf(this.picLocation);
          if (index == -1) {
            locations.unshift(this.picLocation);
          } else if (index == 1) {
            locations.unshift(this.picLocation);
            locations.pop();
          }
        }
        await axios.put(
          `${this.API_URL}/v1/requests/edit-user`,
          {
            _id: this.dataEditUser._id,
            email: this.email,
            name: this.name,
            nik: this.nik,
            title: this.title,
            department: this.department,
            phone: this.phone,
            groupLevel: this.groupLevel,
            location: locations,
            company: this.companies,
            ipUser: this.dataUsers,
            isPjs: this.isPjs,
            isInactive: this.isInactive
          },
          {
            headers: { Authorization: `Bearer ${this.token}` },
          }
        );
        this.backHome();
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.state.loader = false;
      }
    },
  },
  watch: {
    dataEditUser() {
      if (!this.dataEditUser) {
        alert("User Tidak Ditemukan");
        this.$router.push("/user-list");
        return;
      }
      this.email = this.dataEditUser.email;
      this.name = this.dataEditUser.name;
      this.nik = this.dataEditUser.nik;
      this.title = this.dataEditUser.title;
      this.phone = this.dataEditUser.phone[0];
      this.groupLevel = this.dataEditUser.group_level;
      this.department = this.dataEditUser.department;
      this.picLocation = this.dataEditUser.location || "";
      if (this.picLocation instanceof Array) {
        this.picLocation = this.picLocation[0];
      }
      this.companies = this.dataEditUser.companies || [];
      if (!(this.department instanceof Array)) {
        this.department = [this.department];
      }
      this.isPjs = this.dataEditUser.isPjs || false;
      this.isInactive = this.dataEditUser.isInactive ?? false;
      this.device = this.dataEditUser.device || "";
      this.last_login = this.dataEditUser.last_login || "";
    },
  },
};
</script>

<style>
.mustFill {
  color: #ea5164;
}
</style>